<div class="container">
  <div *ngIf="trendingFr.length">
    <div class="trending-setion">
      <h2>Trending Fundraisers</h2>
      <p class="subtext">View the fundraisers that are most active right now</p>
      <div class="card-wrapper widget-height">
        <ngx-glide [showArrows]="true" [showBullets]="false" [breakpoints]="breakpoints" [perView]="3" [bound]="true" [gap]="0" arrowLeftLabel="" arrowRightLabel="">
          <div *ngFor="let fr of trendingFr; index as i">
            <app-widget *ngIf="i !== 2" [widgetData]="fr" [currency]="currency" [showShareBtn]="true"></app-widget>
            <ng-template *ngIf="i === 2" [ngTemplateOutlet]="hfPitchCard" />
          </div>
        </ngx-glide>
      </div>
      <a [routerLink]="['/new/browse']" class="float-right view-more">View More<i class="material-icons">arrow_forward</i></a>
      <!-- <hr class="separator d-lg-none d-md-none"/> -->
    </div>
  </div>
</div>

<ng-template #hfPitchCard>
<div class="hf-pitch-wraper" (click)="goToHf()">
  <div class="try-new">
    <img src="/assets/images/star-1.png" alt="star">
    <span>TRY NEW</span>
  </div>
  <div class="content">
    <div class="head">
      <div class="logo"><img src="/assets/images/ketto-healthfirst-logo-white.png" alt="hf"></div>
    </div>
    <div class="details">
      <div class="sub-title">Secure Your Family From</div>
      <div class="title">Unexpected Medical Expenses</div>
      <div class="desc">Find a HealthFirst plan that helps your family save up to 70% health expenses.</div>
      <div class="offer">
        <div class="start">Plan Starts @</div>
        <div class="amount"><span class="currency">₹ </span>{{vars.insurance_vendors.medibuddy.yearly.essentials.INR | inrFormat}}<span class="year"> /yearly</span></div>
      </div>
    </div>
    <div class="action">
      <button type="button" mat-button>See More <em class="material-icons">arrow_forward_ios</em></button>
    </div>
  </div>
</div>
</ng-template>
